export const SAVE_EMPLOYEE_MODAL = 'employee';
export const SAVE_ORDER_REPORT_MODAL = 'employeeReport';

export const ADD_USERS_FROM_FILE = 'addUsersFromFile';
